var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInformation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.01562 5.57812C5.774 5.57812 5.57812 5.774 5.57812 6.01562C5.57812 6.25725 5.774 6.45312 6.01562 6.45312H6.45312V8.85937H5.6875C5.44588 8.85937 5.25 9.05525 5.25 9.29687C5.25 9.5385 5.44588 9.73438 5.6875 9.73438H8.09375C8.33537 9.73438 8.53125 9.5385 8.53125 9.29687C8.53125 9.05525 8.33537 8.85937 8.09375 8.85937H7.32812V6.01562C7.32812 5.774 7.13225 5.57812 6.89062 5.57812H6.01562Z",
    fill: "#1869EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.38627 3.6745C6.50319 3.59638 6.64064 3.55469 6.78125 3.55469C6.9698 3.55469 7.15063 3.62959 7.28396 3.76292C7.41728 3.89624 7.49219 4.07707 7.49219 4.26562C7.49219 4.40623 7.45049 4.54369 7.37237 4.6606C7.29425 4.77751 7.18322 4.86864 7.05331 4.92245C6.92341 4.97625 6.78046 4.99033 6.64255 4.9629C6.50464 4.93547 6.37797 4.86776 6.27854 4.76833C6.17911 4.66891 6.1114 4.54223 6.08397 4.40432C6.05654 4.26641 6.07062 4.12347 6.12443 3.99356C6.17824 3.86365 6.26936 3.75262 6.38627 3.6745Z",
    fill: "#1869EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.78125 1.3125C3.76123 1.3125 1.3125 3.76123 1.3125 6.78125C1.3125 9.80127 3.76123 12.25 6.78125 12.25C9.80127 12.25 12.25 9.80127 12.25 6.78125C12.25 3.76123 9.80127 1.3125 6.78125 1.3125ZM2.1875 6.78125C2.1875 4.24448 4.24448 2.1875 6.78125 2.1875C9.31802 2.1875 11.375 4.24448 11.375 6.78125C11.375 9.31802 9.31802 11.375 6.78125 11.375C4.24448 11.375 2.1875 9.31802 2.1875 6.78125Z",
    fill: "#1869EF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.7682d3c40364c4fee6f87508661d3245.svg";
export { ForwardRef as ReactComponent };